export default __webpack_public_path__ + "static/media/ojaswi.4a15d369.webp";